<script setup>
defineProps({
  selected: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26 13.9525C26 21.1322 20.1797 26.9525 13 26.9525C5.8203 26.9525 0 21.1322 0 13.9525C0 6.77275 5.8203 0.952454 13 0.952454C20.1797 0.952454 26 6.77275 26 13.9525Z" :fill="selected ? '#021B27' : '#00CAAA'"/>
</svg>

</template>